module.exports = __webpack_public_path__ + "img/pin.svg";